<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-10">
        <h5>{{ $t("Menu.list.titles.stones.library") }}</h5>
      </div>
      <div class="col-2 text-end">
        <img
          :src="appUrl + '/img/icons/close.svg'"
          class="icon top"
          @click="configure('stones')"
          alt="close"
        />
      </div>
    </div>
    <template v-for="(item, index) in possibleItems.list.keywords">
      <div class="row border-bottom" v-bind:key="index">
        <div class="col-12 col-library-group">
          <h5>{{ item.text }}</h5>
          <i
            v-if="
              scrollValues[item.groupId] && scrollValues[item.groupId].arrowLeft
            "
            class="icon-arrow-left"
            :ref="'arrow-left_' + item.groupId"
            @click="scroll('left', item.groupId)"
          >
            <img
              :src="appUrl + '/img/menu/arrow-right.svg'"
              height="19"
              width="9"
            />
          </i>
          <i
            v-if="
              scrollValues[item.groupId] &&
              scrollValues[item.groupId].arrowRight
            "
            class="icon-arrow-right"
            :ref="'arrow-right_' + item.groupId"
            @click="scroll('right', item.groupId)"
          >
            <img
              :src="appUrl + '/img/menu/arrow-right.svg'"
              height="19"
              width="9"
            />
          </i>
        </div>
        <div class="col-12">
          <div
            class="wrapper-overflow"
            :ref="'parent_' + item.groupId"
            @scroll="scrollBrowser(item.groupId)"
          >
            <ul :ref="'wrapper_' + item.groupId">
              <template v-for="(stone, stoneId) in possibleItems.list.library">
                <li
                  v-if="stone.groups.indexOf(parseInt(item.groupId)) != -1"
                  v-bind:key="stoneId"
                  @click="changeItem(stone.itemnumber)"
                >
                  <div class="crop-img">
                    <img
                      :src="
                        getApiHost +
                        '/v2/images/item/f7f5f3/600/600/' +
                        stone.picture.toUpperCase() +
                        '.jpg'
                      "
                      :alt="stone.picture.toUpperCase()"
                    />
                  </div>
                  <p>{{ stone.text }}</p>
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Config from "@/vuex/Config";

export default {
  name: "VariationsStonesLibrary",
  props: ["possibleItems"],
  watch: {
    "possibleItems.list.keywords": {
      handler: function () {
        setTimeout(() => {
          this.$forceUpdate();
        }, 500);
      },
      deep: true,
    },
  },
  updated() {
    if (this.scrollValues.length < 1) {
      for (let i in this.possibleItems.list.keywords) {
        let groupId = this.possibleItems.list.keywords[i].groupId;
        let nodeWidth = this.$refs["wrapper_" + groupId][0].offsetWidth;
        let parentNodeWidth = this.$refs["parent_" + groupId][0].offsetWidth;
        this.scrollValues[groupId] = {
          nodeWidth: nodeWidth,
          parentNodeWidth: parentNodeWidth,
          left: 0,
          arrowRight: nodeWidth > parentNodeWidth,
          arrowLeft: false,
        };
      }
    }
  },
  data() {
    return {
      getApiHost: Config.getters.getApiHost,
      appUrl: Config.getters.getAppUrl,
      scrollStep: 154,
      scrollValues: [],
    };
  },
  methods: {
    scrollBrowser: function (groupId) {
      this.scrollValues[groupId].left =
        this.$refs["parent_" + groupId][0].scrollLeft;

      if (this.scrollValues[groupId].left < 1) {
        this.scrollValues[groupId].arrowLeft = false;
      } else {
        this.scrollValues[groupId].arrowLeft = true;
      }

      if (this.isLastScrollStep(groupId)) {
        this.scrollValues[groupId].arrowRight = false;
      } else {
        this.scrollValues[groupId].arrowRight = true;
      }

      if (
        this.scrollValues[groupId].left < 1 &&
        this.scrollValues[groupId].nodeWidth >
          this.scrollValues[groupId].parentNodeWidth
      ) {
        this.scrollValues[groupId].arrowRight = true;
      }

      this.$forceUpdate();
    },
    scroll: function (direction, groupId) {
      if (direction === "right") {
        this.$refs["parent_" + groupId][0].scrollLeft += this.scrollStep;
        this.scrollValues[groupId].left += this.scrollStep;
        this.scrollValues[groupId].arrowLeft = true;
      } else {
        this.$refs["parent_" + groupId][0].scrollLeft -= this.scrollStep;
        this.scrollValues[groupId].left -= this.scrollStep;
        this.scrollValues[groupId].arrowRight = true;
      }

      if (this.scrollValues[groupId].left < 1) {
        this.$refs["parent_" + groupId][0].scrollLeft = 0;
        this.scrollValues[groupId].left = 0;
        this.scrollValues[groupId].arrowLeft = false;
      }

      if (
        this.scrollValues[groupId].left < 1 &&
        this.scrollValues[groupId].nodeWidth >
          this.scrollValues[groupId].parentNodeWidth
      ) {
        this.scrollValues[groupId].arrowRight = true;
      }

      if (this.isLastScrollStep(groupId)) {
        this.scrollValues[groupId].arrowRight = false;
      }

      this.$forceUpdate();
    },
    isLastScrollStep: function (groupId) {
      return (
        this.scrollValues[groupId].parentNodeWidth >=
          this.scrollValues[groupId].nodeWidth -
            this.scrollValues[groupId].left -
            1 ||
        this.scrollValues[groupId].nodeWidth -
          this.scrollValues[groupId].parentNodeWidth <=
          this.scrollStep
      );
    },
    changeItem: function (itemnumber) {
      this.$parent.$parent.changeItem(itemnumber);
    },
    configure: function (type) {
      this.$root.$emit("configure", type);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#app {
  h5 {
    font-weight: bold;
    font-size: 1em;
    padding-bottom: 0.5em;
  }

  .col-library-group {
    display: flex;
    gap: 2rem;
    margin-bottom: 3rem;
  }

  .icon-arrow-left,
  .icon-arrow-right {
    display: flex;
    flex-shrink: 0;
    border: none;
    cursor: pointer;
  }

  .icon-arrow-left img {
    transform: rotate(180deg);
  }

  .border-bottom {
    padding-bottom: 0.5em;
    border-bottom: solid 0.1em $brandDarkGrey;
    margin-bottom: 1em;

    div.wrapper-overflow {
      overflow: auto;
      scroll-behavior: smooth;
    }
  }

  div.crop-img {
    width: 10em;
    height: 10em;
  }

  ul {
    width: max-content;
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      list-style: none;
      padding: 0;
      margin: 0.2em 0 0.2em 0;
      display: inline-block;
      width: 11em;
      vertical-align: top;
      cursor: pointer;

      p {
        padding: 0 0.75em 0 0.75em;
        font-size: 1em;
      }
    }
  }
}
</style>
